import React from "react";
import MapView from "../../components/common/Map/MapView";
import Heading from "../../components/common/Typography/Heading";
import {
  PUBLIC_HEADING_TO_CONTENT_CLASS,
  PUBLIC_SECTION_GAP_CLASS,
} from "../Public/shared/publicLayoutSpec";

const ServicesOnMap = () => {
  return (
    <>
      <div className={PUBLIC_SECTION_GAP_CLASS}>
        <div className="tp-container-main mx-auto">
          <Heading
            variant={"h2"}
            className={"flex justify-start text-start text-offblack"}
          >
            Popular services around you
          </Heading>
        </div>
        <div className="tp-container-fluid mx-auto">
          <div
            className={`2xl:mx-auto flex justify-center h-[600px] xs:h-[650px] lg:h-[700px] xl:h-[800px] 2xl:h-[1000px] ${PUBLIC_HEADING_TO_CONTENT_CLASS}`}
          >
            <MapView />
          </div>
        </div>
      </div>
    </>
  );
};

export default ServicesOnMap;
